module.exports = __webpack_public_path__ + "menu.png?e7371a9155e909c68a138f092b072acc";